import React from 'react';
import VideoInfoModuleMobile from 'components/templates/videoInfoModuleMobile';
import { StringUtil } from 'utils/StringUtil';
//eslint-disable-next-line
import "./styles.scss";

const HistoryMomentsMobile = ({ data }) => {
  const {
    historyMoments: {
      heading,
      video,
      sub_heading_mobile,
      paragraph_mobile,
      video_thumbnail_url,
    },
  } = data.data;
  const headingData = StringUtil.sliceHtml(heading);
  let subHeading = StringUtil.sliceHtml(sub_heading_mobile);
  const content = StringUtil.sliceHtml(paragraph_mobile);

  return (
    <VideoInfoModuleMobile
      buttonName={''}
      content={content}
      videoData={video}
      heading={headingData}
      subHeading={subHeading}
      containerClass={'history-moments-mobile'}
      videoThumbnailUrl={video_thumbnail_url}
    />
  );
};

export default HistoryMomentsMobile;
